import * as React from "react";
import { localeStore } from "src/i18n/locale-store";

interface ILocaleContext {
  locale: string;
  setLocale: (locale: string) => void;
}

export const { Consumer, Provider } = React.createContext<ILocaleContext>({
  locale: localeStore.getLanguage(),
  setLocale: () => null
});



// WEBPACK FOOTER //
// ./src/components/localization/locale-context.tsx